// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1U3SB","footer":"ModalFilter_footer__3TgFv"};